export default "__VITE_ASSET__1v6KaGKr__"